// Color scheme — dark terminal ("moonfly"): saturated hues on near-black so the
// network reads like a CRT readout. Cool blues/green/teal = PCKT & the network;
// hot reds/amber/magenta/purple = corruption.
export const Palette = {
  bg: "#080808",
  bgGrid: "#1f2123",
  bgGridBright: "#323437",

  // PCKT (you)
  pckt: "#80a0ff",
  pcktCore: "#e4e4e4",
  pcktTrail: "#80a0ff",

  // Resources
  integrity: "#8cc85f", // green = health
  bandwidth: "#74b2ff", // blue = xp
  fragment: "#c6c684", // yellow = currency
  signal: "#cf87e8", // magenta = ultimate

  // Enemies (corruption)
  virus: "#ff5454",
  worm: "#e3c78a",
  trojan: "#e3c78a",
  thief: "#ae81ff",
  noise: "#949494",
  glitch: "#36c692",
  corruptor: "#ff5189",
  blackout: "#5a4b8a",
  flood: "#ff5189",

  // Bosses
  boss: "#ff5454",
  zeroDay: "#cf87e8",

  // FX
  hit: "#e4e4e4", // light damage numbers on dark
  crit: "#e3c78a", // amber crits
  danger: "#ff5454",
  node: "#79dac8", // online node (teal)
  nodeDead: "#565656", // offline node (gray)
} as const;

export type PaletteKey = keyof typeof Palette;
